const loadMoreEl = document.querySelector('.load-more')

function loadMore () {
  let loaded
  const loadedEl = loadMoreEl.querySelector('.load-more-loaded')
  const totalEl = loadMoreEl.querySelector('.load-more-total')

  const loadMoreButton = loadMoreEl.querySelector('.load-more .show-more')
  const hRule = loadMoreEl.querySelector('.load-more hr')
  const totalCards = loadMoreEl.querySelectorAll('.load-more-card')
  if (totalEl) totalEl.innerText = totalCards.length

  function setResults (num = 6) {
    loaded = num
    if (loadedEl) loadedEl.innerText = num

    Array.from(totalCards).forEach((item, index) => {
      if (index + 1 > loaded) {
        item.classList.add('is-hidden')
      } else {
        item.classList.remove('is-hidden')
      }
    })
  }

  loadMoreButton.addEventListener('click', () => {
    if (loaded + 6 >= totalCards.length) {
      loaded = totalCards.length
      loadMoreButton.classList.add('is-hidden')
      hRule.style.marginRight = '0'
    } else {
      loaded += 6
    }
    setResults(loaded)
  }, { passive: true })

  const visibleEl = Math.min(6, totalCards.length)
  setResults(visibleEl)

  if (totalCards.length <= 6) {
    loadMoreButton.classList.add('is-hidden')
    hRule.style.marginRight = '0'
  }
}

if (loadMoreEl) loadMore()
